import PropTypes from 'prop-types'
import React from 'react'

export const IconFAThumbtackRaw = ({ className, width, height }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 384 512'
      data-icon='thumbtack'
      width={width}
      height={height}
    >
      <path
        shapeRendering='geometricPrecision'
        fill='currentColor'
        d='M64 0H32V64H64 93.5L82.1 212.1C23.7 240.7 0 293 0 320v32H384V320c0-22.5-23.7-76.5-82.1-106.7L290.5 64H320h32V0H320 64zm96 480v32h64V480 384H160v96z'
      />
    </svg>
  )
}

IconFAThumbtackRaw.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
